import { EventContext, Fields } from '@vimeo/bigpicture-client';

import { createNullObject, PartialWithRequired } from './utils';

export const thirdPartyIntegrationBpContextName = 'third_party_integration_context';
export const thirdPartyIntegrationBpContextSchemaVersion = 5;
export type ThirdPartyIntegrationBpContext = Fields<
  typeof thirdPartyIntegrationBpContextName,
  typeof thirdPartyIntegrationBpContextSchemaVersion
>;

const defaults = createNullObject([
  'app_id',
  'integration_type',
  'managed_user_id',
  'partner_bucket',
]);

export const buildThirdPartyIntegrationBpContext = (
  fields: PartialWithRequired<
    ThirdPartyIntegrationBpContext,
    'integration_id' | 'integration_name' | 'is_partner'
  >,
) => {
  return {
    third_party_integration_context: new EventContext(
      thirdPartyIntegrationBpContextName,
      thirdPartyIntegrationBpContextSchemaVersion,
      {
        is_integration: fields.integration_id !== null,
        ...defaults,
        ...fields,
      },
    ),
  };
};
